import { takeLeading } from 'redux-saga/effects';
import { FETCH_BONUSES_CONTENT_REQUEST } from '../../constants/bonuses';
import { FETCH_CONFIGURATION_REQUEST } from '../../constants/configuration';
import { loadBonusesContent } from './loadBonusesContent';
import { loadConfiguration } from './loadConfiguration';

export function* fetchWatcher() {
  yield takeLeading(FETCH_BONUSES_CONTENT_REQUEST, loadBonusesContent);
  yield takeLeading(FETCH_CONFIGURATION_REQUEST, loadConfiguration);
}
